export enum AccessStatus {
  SCHEDULE_HAS_BEEN_CANCELLED = "SCHEDULE_HAS_BEEN_CANCELLED",
  SCHEDULE_NOT_STARTED = "SCHEDULE_NOT_STARTED",
  SCHEDULE_TIME_COMPLETED = "SCHEDULE_TIME_COMPLETED",
  LOGIN_WINDOW_COMPLETED = "LOGIN_WINDOW_COMPLETED",
  MAX_ATTEMPT_EXCEEDED = "MAX_ATTEMPT_EXCEEDED",
  IN_PROGRESS = "IN_PROGRESS",
  PROGRESS_NOT_STARTED = "PROGRESS_NOT_STARTED",
  ATTEMPT_IN_RESULT_PROCESSING = "ATTEMPT_IN_RESULT_PROCESSING",
  NOT_SCHEDULED = "NOT_SCHEDULED",
  COOL_OFF_PERIOD_NOT_FINISHED = "COOL_OFF_PERIOD_NOT_FINISHED"
}

export type AccessStatusType = AccessStatus | keyof typeof AccessStatus;
